import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaGlobe,
  FaUser,
  FaBuilding,
  FaPaperPlane,
  FaCheckCircle,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaMobile,
  FaHeadset,
  FaQuestionCircle,
  FaHandshake,
  FaShieldAlt,
} from "react-icons/fa";
import { captchaUrl, contactUrl } from "../shared/urlHelper";
import "./ContactPage.css";

const ContactPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Dynamic calculation of years since company founding
  const yearsInBusiness = new Date().getFullYear() - 1989;

  const stats = [
    {
      value: "Vzdialená pomoc",
      label: "stiahnite si",
      href: "https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/XESTMJSAG21O/AnyDeskInverPreklientov.exe",
      rel: "noopener noreferrer",
    },
    {
      value: "Vstup do podpory",
      label: "Pre klientov",
      href: "/podpora",
      rel: "noopener noreferrer",
    },
    {
      value: `Webmail`,
      label: "Mail",
      href: "https://webmail.inver.sk",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      value: "Zmena hesla",
      label: "Pre webMail",
      href: "https://m.inver.sk/pwchange",
      target: "_blank",
      rel: "noopener noreferrer",
    },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    subject: "",
    message: "",
    service: "",
    agreement: false,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCaptchaChange = async (value) => {
    setCaptchaValue(value);
    console.log("Captcha URL:", captchaUrl);
    if (value) {
      try {
        const response = await fetch(captchaUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: value }),
        });

        const result = await response.json();
        console.log("Captcha verification result:", result);
        setCaptchaVerified(result.success || false);

        if (!result.success) {
          setCaptchaError(true);
        }
      } catch (error) {
        console.error("Captcha verification error:", error);
        setCaptchaVerified(false);
        setCaptchaError(true);
      }
    } else {
      setCaptchaVerified(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if captcha is completed
    if (!captchaValue) {
      setCaptchaError(true);
      return;
    }

    // Here would be actual form submission logic
    setIsSubmitted(true);
    // tu dopln odoslanie mail cez api api je contactUrl
    fetch(contactUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        setIsSubmitted(false);
        setCaptchaValue(null);
        setCaptchaVerified(false);

        // Reset form
        setFormData({
          name: "",
          email: "",
          company: "",
          phone: "",
          subject: "",
          message: "",
          service: "",
          agreement: false,
        });
      })
      .catch((error) => {
        console.error("Form submission error:", error);
      });
  };

  const contactInfo = [
    {
      icon: FaPhone,
      title: "Telefón",
      content: "+421 55 7 999 111",
      description: "Hlavná linka - pracovné dni 8:00-17:00",
    },
    {
      icon: FaMobile,
      title: "Mobil",
      content: "+421 55 7 999 111",
      description: "Urgentné problémy a podpora",
    },
    {
      icon: FaEnvelope,
      title: "Email",
      content: "inver@inver.sk",
      description: "Odpoveď do 24 hodín",
    },
    {
      icon: FaGlobe,
      title: "Web",
      content: "www.inver.sk",
      description: "Oficiálne webové stránky",
    },
    {
      icon: FaMapMarkerAlt,
      title: "Adresa",
      content: "Hutnícka 1 (4. poschodie), 040 01 Košice",
      description: "Slovenská republika",
    },
    {
      icon: FaClock,
      title: "Pracovný čas",
      content: "Po - Pi: 8:00 - 17:00",
      description: "So: 9:00 - 12:00 (len podpora)",
    },
  ];

  const departments = [
    {
      icon: FaHeadset,
      name: "Technická podpora",
      email: "podpora@inver.sk",
      phone: "+421 55 / 622 3457",
      description: "Pomoc s HERKULES, ŠPEDÍCIA, PREDAJŇA",
    },
    {
      icon: FaHandshake,
      name: "Obchod a predaj",
      email: "obchod@inver.sk",
      phone: "+421 55 / 622 3458",
      description: "Cenové ponuky a implementácia systémov",
    },
    {
      icon: FaBuilding,
      name: "Vedenie spoločnosti",
      email: "vedenie@inver.sk",
      phone: "+421 55 / 622 3456",
      description: "Strategické partnerstvá a rozvojové projekty",
    },
    {
      icon: FaQuestionCircle,
      name: "Všeobecné informácie",
      email: "inver@Inver.sk",
      phone: "+421 55 / 622 3456",
      description: "Základné informácie o produktoch a službách",
    },
  ];

  const serviceTypes = [
    "IT Outsourcing",
    "Kybernetická bezpečnosť",
    "Webhosting a domény",
    "Vývoj softvéru",
    "Herkules účtovníctvo",
    "Špedícia logistika",
    "Predajňa POS",
    "Technická podpora",
    "Školenia",
    "Iné",
  ];

  const socialMedia = [
    { icon: FaLinkedin, url: "#", name: "LinkedIn" },
    { icon: FaFacebook, url: "#", name: "Facebook" },
    { icon: FaTwitter, url: "#", name: "Twitter" },
    { icon: FaInstagram, url: "#", name: "Instagram" },
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <h1>Kontaktujte nás</h1>
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div
              onClick={() => {
                if (stat.target === "_blank") {
                  window.open(stat.href, "_blank");
                } else {
                  window.location.href = stat.href;
                }
              }}
              key={index}
              className="hero-stat"
              style={{ cursor: "pointer" }}
            >
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Introduction Section */}
      <section className="contact-intro">
        <div className="container">
          <div className="intro-content">
            <h2>Sme tu pre vás</h2>
            <p>
              Napíšte nám, zavolajte alebo nás navštívte. Radi vám pomôžeme s
              vašimi IT potrebami a poskytneme odborné poradenstvo pre váš
              biznis. Naši experti sú pripravení diskutovať o vašich projektoch
              a nájsť najlepšie riešenie.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <div className="container">
          <h2>Kontaktné informácie</h2>
          <div className="contact-info-grid">
            {contactInfo.map((info, index) => (
              <div key={index} className="contact-info-card">
                <div className="info-icon">
                  <info.icon />
                </div>
                <div className="info-content">
                  <h4>{info.title}</h4>
                  <p className="info-main">{info.content}</p>
                  <p className="info-description">{info.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="main-contact-section">
        <div className="container">
          <div className="contact-content-centered">
            

            <div className="contact-form-section-wide">
              <div className="form-header">
                <h2>Napíšte nám</h2>
                <p>Vyplňte formulár a my sa vám ozveme do 24 hodín</p>
              </div>

              {isSubmitted && (
                <div className="success-message">
                  <FaCheckCircle />
                  <span>Ďakujeme! Vaša správa bola úspešne odoslaná.</span>
                </div>
              )}

              <form className="contact-form-wide" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Meno a priezvisko *</label>
                    <div className="input-with-icon">
                      <FaUser />
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Vaše meno"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <div className="input-with-icon">
                      <FaEnvelope />
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="vas@email.sk"
                      />
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="company">Spoločnosť</label>
                    <div className="input-with-icon">
                      <FaBuilding />
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        placeholder="Názov spoločnosti"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Telefón</label>
                    <div className="input-with-icon">
                      <FaPhone />
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="+421 xxx xxx xxx"
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service">Typ služby</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                  >
                    <option value="">Vyberte službu</option>
                    {serviceTypes.map((service, index) => (
                      <option key={index} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Predmet *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    placeholder="Stručný popis vašej požiadavky"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Správa *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    placeholder="Detailne opíšte vašu požiadavku alebo problém..."
                  ></textarea>
                </div>

                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="agreement"
                      checked={formData.agreement}
                      onChange={handleInputChange}
                      required
                      className="standard-checkbox"
                    />
                    <span className="checkbox-text">
                      Súhlasím so spracovaním osobných údajov podľa GDPR
                    </span>
                  </label>
                </div>

                <div
                  className={`form-group captcha-group ${
                    captchaVerified ? "verified" : ""
                  }`}
                >
                  <label className="captcha-label">
                    <FaShieldAlt />
                    Bezpečnostné overenie
                  </label>
                  <p className="captcha-description">
                    Potvrďte, že ste človek pre odoslanie formulára
                  </p>
                  <div className="captcha-container">
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={handleCaptchaChange}
                      theme="light"
                      size="normal"
                      value={captchaValue}
                    />
                  </div>
                  {captchaError && (
                    <div className="captcha-error">
                      <span>Prosím, dokončite bezpečnostné overenie </span>
                    </div>
                  )}
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  <FaPaperPlane />
                  Odoslať správu
                </button>
              </form>
            </div>

            {/* Departments*/}
            {/* <div className="departments-section">
              <h2>Naše oddelenia</h2>
              <p>Kontaktujte priamo príslušné oddelenie</p>

              <div className="departments-list">
                {departments.map((dept, index) => (
                  <div key={index} className="department-card">
                    <div className="dept-icon">
                      <dept.icon />
                    </div>
                    <div className="dept-info">
                      <h4>{dept.name}</h4>
                      <p>{dept.description}</p>
                      <div className="dept-contact">
                        <a href={`mailto:${dept.email}`} className="dept-email">
                          <FaEnvelope />
                          {dept.email}
                        </a>
                        <a href={`tel:${dept.phone}`} className="dept-phone">
                          <FaPhone />
                          {dept.phone}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2>Kde nás nájdete</h2>
          <div className="map-content">
            <div className="map-container">
              <div className="map-header">
                <FaMapMarkerAlt />
                <div>
                  <h3>Naša lokalita</h3>
                  <p>Hutnícka 1 (4. poschodie), 040 01 Košice</p>
                </div>
              </div>
              <div className="map-embed">
                <iframe
                  src="https://www.openstreetmap.org/export/embed.html?bbox=21.256,48.727,21.261,48.731&layer=mapnik&marker=48.7290,21.2587"
                  width="100%"
                  height="350"
                  style={{ border: 0, borderRadius: "12px" }}
                  allowFullScreen=""
                  loading="lazy"
                  title="INVER - Hutnícka 1, Košice - OpenStreetMap"
                ></iframe>
                <div className="map-links-osm">
                  <a
                    href="https://www.openstreetmap.org/?mlat=48.7164&mlon=21.2589#map=16/48.7164/21.2589&layers=N"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="osm-link"
                  >
                    📍 Zobraz na OpenStreetMap
                  </a>
                  <a
                    href="https://www.google.com/maps/place/INVER+spol.+s+r.o./@48.7290715,21.2588559,18z/data=!3m1!4b1!4m6!3m5!1s0x473ee06204abfb37:0x8b90f7b3e936871a!8m2!3d48.7290715!4d21.2588559!16s%2Fg%2F11bzx340k6?entry=ttu&g_ep=EgoyMDI1MTAyMi4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="osm-link"
                  >
                    🗺️ Otvoriť v Google Maps
                  </a>
                  <a
                    href="https://waze.com/ul?ll=48.7164%2C21.2589&navigate=yes&zoom=17"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="osm-link waze-link"
                  >
                    🚗 Navigovať cez Waze
                  </a>
                </div>
              </div>
            </div>
            <div className="map-info">
              <h4>Ako sa k nám dostanete</h4>
              <ul>
                <li>
                  <strong>Autom:</strong> Parkovanie v okolí budovy na Hutníckej
                  ulici
                </li>
                <li>
                  <strong>MHD:</strong> Zastávky "Mlynská bašta", "Železničná
                  nemocnica" alebo " Nám. Maratónu mieru"
                </li>
                <li>
                  <strong>Vlakom:</strong> 10 minút pešo od hlavnej železničnej
                  stanice Košice
                </li>
                <li>
                  <strong>Letisko:</strong> Letisko Košice - 8 km (15 minút
                  autom)
                </li>
              </ul>
              <div className="office-hours">
                <h5>Úradné hodiny</h5>
                <p>
                  <strong>Pondelok - Piatok:</strong> 8:00 - 17:00
                </p>
                <p>
                  <strong>Sobota:</strong> 9:00 - 12:00 (len podpora)
                </p>
                <p>
                  <strong>Nedeľa:</strong> Zatvorené
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Media & Newsletter
      <section className="social-section">
        <div className="container">
          <div className="social-content">
            <div className="social-media">
              <h3>Sledujte nás</h3>
              <p>Najnovšie informácie a tipy na sociálnych sieťach</p>
              <div className="social-links">
                {socialMedia.map((social, index) => (
                  <a key={index} href={social.url} className="social-link" title={social.name}>
                    <social.icon />
                  </a>
                ))}
              </div>
            </div>
            
            <div className="newsletter">
              <h3>Newsletter</h3>
              <p>Prihláste sa k odberu noviniek a tipov</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Váš email" />
                <button className="btn btn-primary">
                  Prihlásiť sa
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default ContactPage;
